import { useModalPromises } from "kreate-common/modules/kreate-ui/components/Modal/hoc/withModalPromises";

import ModalAsyncGenerator from ".";

export function useModalTrigger$ModalAsyncGenerator() {
  const { showModal } = useModalPromises();

  const openModal = async function <T>(
    task: () => AsyncGenerator<React.ReactNode, T>
  ) {
    return await showModal<T>(({ resolve, reject }) => (
      <ModalAsyncGenerator onResolve={resolve} onReject={reject}>
        {task}
      </ModalAsyncGenerator>
    ));
  };

  return { openModal };
}

// NOTE: @kien-kreate: we can eliminate this function by
// making ModalAsyncGenerator accept:
// AsyncGenerator<React.ReactNode | (resolve, reject) => React.ReactNode, T>
export async function* waitModal<T = void>(
  render: (
    resolve: (value: T) => void,
    reject: (reason: unknown) => void
  ) => React.ReactNode
): AsyncGenerator<React.ReactNode, T> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let resolve: any, reject: any;

  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  yield render(resolve, reject);
  const result = await promise;
  yield null;
  return result;
}
